export default __webpack_public_path__ + "244c88da64d5aca8a7de0b0ed81cd956.png";